import PropTypes from "prop-types"

import PeriodSelectionHOC from "../period_selection_hoc"
import topPublishedAppletsFetcher from "./top_published_applets_fetcher"
import WebAppletCard from "shared/components/applet_card"

import "../stats.scss"

const TopPublishedApplets = ({
  data: { topPublishedApplets },
  categoryName,
  worksWithChannelName,
  appletDetailsUrl,
}) => {
  const name = categoryName || worksWithChannelName || ""
  return (
    <>
      <ul styleName="top-applets-container">
        {topPublishedApplets.slice(0, 6).map((topPublishedApplet, i) => (
          <li key={i} styleName="web-applet-card" className="web-applet-card">
            <a
              className="applet-card-body"
              style={{ backgroundColor: topPublishedApplet.applet.brand_color }}
              href={`${appletDetailsUrl}/${topPublishedApplet.applet.id}`}
            >
              <WebAppletCard applet={topPublishedApplet.applet} />
            </a>
          </li>
        ))}
        {topPublishedApplets.length === 0 && (
          <div>
            There were no {name} Applets published over the selected date range.
          </div>
        )}
      </ul>
      <div className="action-buttons-container">
        <a
          role="button"
          className="button-secondary button-outlined"
          href={appletDetailsUrl}
        >
          View all top published Applets
        </a>
      </div>
    </>
  )
}

TopPublishedApplets.propTypes = {
  data: PropTypes.shape({
    topPublishedApplets: PropTypes.arrayOf(PropTypes.object),
  }),
  categoryName: PropTypes.string,
  worksWithChannelName: PropTypes.string,
  appletDetailsUrl: PropTypes.string,
}

export default PeriodSelectionHOC({
  WrappedComponent: TopPublishedApplets,
  serviceMetricsFetcher: topPublishedAppletsFetcher,
  fetchDailyComparisonData: false,
})
